export function formatRating(rating: number) {
  return Number(Math.floor(rating * 100) / 100).toFixed(2);
}
